import { render, staticRenderFns } from "./VersionTableRow.vue?vue&type=template&id=1dd581ec&"
import script from "./VersionTableRow.vue?vue&type=script&lang=ts&"
export * from "./VersionTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./VersionTableRow.vue?vue&type=style&index=0&id=1dd581ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports